<template>
  <el-form class="v-dynamic-form" :model="value" label-position="right" label-width="100px" ref="pluginDynamic" :disabled="fromDisabled">

      <v-dynamic-form-item
      v-for="item in formConfig.properties"
      :key="item.key"
      :item="item"
      :value="value[item.key]"
      @input="handleInput($event, item.key)"
      :style="{'min-width':columnMinWidth}"
      @addPro="handleAddPro"
      @delPro="handleDelPro"></v-dynamic-form-item>

    <slot/>
  </el-form>
</template>
<script>
export default {
  props: {
    formConfig: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    columnMinWidth: {
      type: String,
    },
    fromDisabled: {
      type: Boolean,
    },
  },
  methods: {
    handleInput(val, key) {
      // 这里element-ui没有上报event，直接就是value了
      this.$emit('input', { ...this.value, [key]: val });
    },
    setDefaultValue() {
      const formData = { ...this.value };
      // 设置默认值
      this.formConfig.properties.forEach((item) => {
        const { key, value } = item;
        if (formData[key] === undefined || formData[key] === null) {
          formData[key] = value;
        }
      });
      this.$emit('input', { ...formData });
    },
    handleAddPro() {
      this.$emit('addPro');
    },
    handleDelPro(index) {
      this.$emit('delPro', index);
    },
  },
  mounted() {
    // this.setDefaultValue();
  },
};
</script>
<style lang="scss">
.v-dynamic-form {
  .el-form-item__label {
  line-height: 1;
  padding: 11px 12px 11px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v-dynamic-form.vue